import { render, staticRenderFns } from "./DispatchFailureParts.vue?vue&type=template&id=61b04428"
import script from "./DispatchFailureParts.vue?vue&type=script&lang=js"
export * from "./DispatchFailureParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports